import { Box } from "@mui/material";

import { SubmitButton } from "@covertree/ui";

import { useCheckout } from "../../CheckoutProvider";
import { AgentConsents } from "./AgentConsents";
import { ConsumerConsents } from "./ConsumerConsents";

interface Props {
  disabled?: boolean;
  loading?: boolean;
}

export function ConfirmPurchase({ disabled }: Props) {
  const { anythingLoading, isD2C, paymentLoading } = useCheckout();

  return (
    <Box mt={3}>
      {isD2C ? <ConsumerConsents /> : <AgentConsents />}
      <SubmitButton
        disabled={disabled || anythingLoading}
        loading={paymentLoading}
        fullWidth={false}
        dataTestId="purchase-button">
        {isD2C ? "Purchase Your Policy" : "Purchase Policy"}
      </SubmitButton>
    </Box>
  );
}
